import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { MonoLabel, cn, focusRingOnDark } from '@/design-system';

export interface AdminHeaderProps {
    eyebrow: string;
    title: string;
    /** Terug naar de lijst waar dit detail uit komt. */
    back?: { to: string; label: string };
    actions?: ReactNode;
}

/**
 * De donkere kopbalk van het platformbeheer. Dezelfde vormtaal als de
 * kantoorschermen, maar zonder omgeving: een beheerder werkt boven de
 * organisaties, niet in één ervan.
 */
export function AdminHeader({ eyebrow, title, back, actions }: AdminHeaderProps) {
    return (
        <header className="flex shrink-0 flex-wrap items-end justify-between gap-5 bg-[var(--ink-800)] px-7 py-5">
            <div className="min-w-0">
                {back ? (
                    <Link
                        to={back.to}
                        className={cn(
                            'mb-2 inline-block rounded-[2px] text-[12px] text-[var(--text-on-dark-2)] underline-offset-2 hover:underline',
                            focusRingOnDark,
                        )}
                    >
                        {`← ${back.label}`}
                    </Link>
                ) : null}
                <div className="mb-[6px]">
                    <MonoLabel size={10} tone="onDarkMuted" as="div" className="truncate">
                        {eyebrow}
                    </MonoLabel>
                </div>
                <h1 className="m-0 truncate font-[family-name:var(--font-display)] text-[24px] leading-[1.15] font-semibold tracking-[-0.02em] text-[var(--text-on-dark)]">
                    {title}
                </h1>
            </div>
            {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
        </header>
    );
}
